import { useParams } from "react-router";
import { KEY, GET_REDE_BY_ID } from "../../Graphql/QUERIES";
import { useQuery } from "@apollo/client";

import { Typography } from "@material-ui/core";
import { useEffect} from "react";
import BottomBar from "../../components/BottomBar";
import TopBar from "../../components/TopBar";
import { useTheme } from "../../hooks/useTheme";

import { useStyles } from './styles'
import PageContainer from "../../components/PageContainer";
import ServiceTab from "../../components/ServiceTab";
import wave0 from '../../assets/wave2.png';
import wave1 from '../../assets/wave-social.png';
import wave2 from '../../assets/wave-health.png';
import wave3 from '../../assets/wave-leizure.png';
import wave4 from '../../assets/wave-culture.png';
import wave5 from '../../assets/wave-education.png';

function ServiceType() {
  const classes = useStyles()
  const { changeTheme } = useTheme();
  const { redeId } = useParams();
  const { loading, error, data } = useQuery(GET_REDE_BY_ID, {
    variables: { token: KEY, Id: parseInt(redeId) },
  })

  const waves = [wave1, wave2, wave3, wave4, wave5];

  const setWaveColor = (redeId) => {
    if (waves[redeId - 1] === undefined) return wave0;
    return waves[redeId - 1]
  }

  useEffect(() => {
    changeTheme(redeId);
  }, [])
  if (loading) return(
    <>
      <TopBar>
        <Typography variant="h1">
          Carregando...
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography 
            variant="body1" 
            color="textPrimary"
            className={classes.description}
          >
            Encontre na lista a seguir serviços na área de carregando....
          </Typography>
        </div>
      </PageContainer>
      <BottomBar/>
    </>
  );
  if (error) return(
    <>
      <TopBar>
        <Typography variant="h1">
          Erro
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography 
            variant="body1" 
            color="textPrimary"
            className={classes.description}
          >
            Ops! Parece que ocorreu um erro.
            Tente novamente mais tarde.
          </Typography>
        </div>
      </PageContainer>
      <BottomBar/>
    </>
  )

  return(
    <>
      <TopBar>
        <Typography variant="h1">
          {data.TipoRedeById[0].nome}
        </Typography>
      </TopBar>
      <PageContainer>
        <div className={classes.wrapper}>
          <Typography 
            variant="body1" 
            color="textPrimary"
            className={classes.description}
          >
            Encontre na lista a seguir tipos de serviços na área de {data.TipoRedeById[0].nome}.
          </Typography>

          <ServiceTab/>

        </div>
      </PageContainer>
        <div className={classes.waveBottom}>
          <img src={setWaveColor(redeId)} alt="onda"/>
        </div>
      <BottomBar/>
    </>
  );
}

export default ServiceType;